import React, { useState } from 'react';
import api from '../api';

export default function RegisterPage() {
    const [formData, setFormData] = useState({
        email: '',
        username: '',
        password: '',
        confirmPassword: ''
    });
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');

        try {
            const response = await api.post('/auth/register', formData);

            if (response.status >= 200 && response.status < 300) {
                setMessage('✅ Registration successful!');
            } else {
                setMessage('❌ ' + (response.data?.message || JSON.stringify(response.data)));
            }
        } catch (error) {
            setMessage('❌ Error: ' + (error.response?.data?.message || error.message));
        }
    };

    return (
        <div className="container mt-5" style={{ maxWidth: '500px' }}>
            <h2>Register</h2>
            {message && <div className="alert alert-info">{message}</div>}
            <form onSubmit={handleSubmit}>
                <input type="email" name="email" placeholder="Email"
                       className="form-control mb-3" value={formData.email} onChange={handleChange} required />
                <input type="text" name="username" placeholder="Username"
                       className="form-control mb-3" value={formData.username} onChange={handleChange} required />
                <input type="password" name="password" placeholder="Password"
                       className="form-control mb-3" value={formData.password} onChange={handleChange} required />
                <input type="password" name="confirmPassword" placeholder="Confirm Password"
                       className="form-control mb-3" value={formData.confirmPassword} onChange={handleChange} required />
                <button className="btn btn-primary w-100">Register</button>
            </form>
        </div>
    );
}
